/**
 * (c) 2021 - 2022, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
export const docStyles = {
  "p,h3": {
    maxWidth: "600px",
  },
  listStylePosition: "inside",
  ol: {
    pl: 3,
  },
  ul: { listStyleType: "disc", pl: 3 },
};
